import { render } from "./terms.vue?vue&type=template&id=1c6e9a43&ts=true"
import script from "./terms.vue?vue&type=script&lang=ts"
export * from "./terms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__